import $ from "jquery";
import { API } from "./api";
import { Params, Preference, DefaultExistingParams } from "./data-structures";
import { DataConversion } from "./data-conversion";
import "jquery-ui/ui/widgets/slider"
import usaj_ga from '../Analytics/usaj-analytics'
declare function retrieveUserPreferences(): any;
declare var gAliasMapping: any;
declare var brandedSearch: Params;

export interface StoredResult {
    SavedSearchParams: string;
    SearchResult: Results;
}

export interface Results {
    Jobs: Job[];
    Total: number;
    Pages: number;
    Pager: Pager;
    Filters: Filters;
    Suggestion: string;
    SortField: string;
}

export interface SavedSearchResult {
    message: string;
    searchID: number;
    field?: string;
}

export interface Job {
    Title: string;
    Agency: string;
    Department: string;
    SalaryDisplay: string;
    DocumentID: string;
    PositionID: string;
    Location: string;
    DateDisplay: string;
    WorkSchedule: string;
    WorkType: string;
    HiringPath: string;
}

export interface Filters {
    FilterType: string;
    Items: Filter[];
}

export interface Filter {
    Value: string;
    Name: string;
    Count: string;
    Selected: boolean;
    Tooltip: string;
    GroupText: string;
}

export class URLCriteriaHelper {
    static ParseURL(aliasMapping, existingParams: Params) {
        var myParams: Params = existingParams ? existingParams : new Params();
        let queryData = new URLSearchParams(window.location.search);
        let querySet = new Set(queryData.keys());
        for (const criteria of querySet) {
            if (criteria in aliasMapping) {
                var queryValues = queryData.getAll(criteria);
                if (myParams[aliasMapping[criteria].JOAQueryName] instanceof Array) {
                    myParams[aliasMapping[criteria].JOAQueryName] = queryValues;
                } else {
                    var firstValue = queryValues[0];
                    if (firstValue === "true") {
                        myParams[aliasMapping[criteria].JOAQueryName] = true;
                    } else if (firstValue === "false") {
                        myParams[aliasMapping[criteria].JOAQueryName] = false;
                    } else {
                        myParams[aliasMapping[criteria].JOAQueryName] = firstValue;
                    }
                }
            }
        }

        return myParams;
    }
        
    static ConstructURL(myParams, aliasMapping, replace?: boolean) {
        let urlObject = {};
        for (var param in myParams) {
            if (param in aliasMapping) {
                urlObject[aliasMapping[param].Abbreviation] = myParams[param]
            }
        }
        for (var key in urlObject) {
            if (URLCriteriaHelper.isEmpty(urlObject[key])) {
                delete urlObject[key];
            }
        }
        if (replace) {
            history.replaceState({}, document.title, window.location.href.split('?')[0] + "?" + $.param(urlObject, true));
        } else {
            history.pushState({}, document.title, window.location.href.split('?')[0] + "?" + $.param(urlObject, true));
        }
    }

    static isEmpty(value) {
        if (Array.isArray(value)) {
            return value === null || value.length < 1;
        }
        return value === null || value === "";
    }
}

export interface Pager {
    CurrentPageIndex: number;
    FirstPageIndex: number;
    HasNextPage: boolean;
    HasPreviousPage: boolean;
    ItemsPerPage: number;
    LastPageIndex: number;
    NextPageIndex: number;
    NumberOfItems: number;
    NumberOfPages: number;
    PreviousPageIndex: number;
}

export namespace GlobalVariables {
    let aliasMapping = gAliasMapping;
    let params: Params;
    if (brandedSearch) {
        var existingParams = JSON.parse(JSON.stringify(brandedSearch));
        params = DefaultExistingParams(existingParams);
    }
    else {
        params = new Params();
    }
    params = URLCriteriaHelper.ParseURL(aliasMapping, params);
    checkForRemoteLocation();
    let prefs: { [id: string]: Preference; } = {};
    let removedPrefs: string[] = [];
    let templates: { [id: string]: HandlebarsTemplateDelegate; } = {};
    let filterCount: number = 0;
    let profileFilterCount: number = 0;
    let jobCount: number = 0;
    let savedSearchParams: string;

    export function getAliasMapping() {
        return aliasMapping;
    }

    export function getParams() {
        return params;
    }

    export function setParams(Params: Params) {
        params = Params;
    }

    export function getTemplates() {
        return templates;
    }

    export function setTemplates(temps: { [id: string]: HandlebarsTemplateDelegate; }) {
        templates = temps;
    }

    export function getFilterCount() {
        return filterCount;
    }

    export function setFilterCount(FilterCount: number) {
        filterCount = FilterCount < 0 ? 0 : FilterCount;
    }

    export function getProfileFilterCount() {
        return profileFilterCount;
    }

    export function setProfileFilterCount(count: number) {
        profileFilterCount = count;
    }

    export function getBrandedSearch() {
        return brandedSearch;
    }

    export function getProfilePreferences() {
        return prefs;
    }

    export function setProfilePreferences(preferences: { [id: string]: Preference }) {
        prefs = preferences;
    }

    export function getProfileRemovedPreferences() {
        return removedPrefs;
    }

    export function setProfileRemovedPreferences(removed: string[]) {
        removedPrefs = removed;
    }

    export function getSavedSearchParams() {
        return savedSearchParams;
    }

    export function setSavedSearchParams(SavedSearchParams: string) {
        savedSearchParams = SavedSearchParams;
    }

    export function parseSavedSearchParams(savedSearchParams: string) {
        if (savedSearchParams != "" && savedSearchParams != "null") {
            setSavedSearchParams(savedSearchParams);
            let params: Params = JSON.parse(savedSearchParams);
            delete params.SavedSearchID
            $('.view-search-name').html(params.SavedSearchName ?? "");
            URLCriteriaHelper.ConstructURL(params, aliasMapping, true);
        }
    }

    export function setJobCount(count: number) {
        jobCount = count;
    }

    export function getJobCount() {
        return jobCount;
    }
    
    function checkForRemoteLocation() {
        for (var i = 0; i < params.LocationName.length; i++) {
            if ("remote" === params.LocationName[i].toLowerCase()) {
                params.LocationName.splice(i, 1);
                params.RemoteIndicator = true;
            }
        }
    }
}

export namespace GlobalFunctions {
    var selectAllFilterList = $('.usajobs-search-filters__select-toggle').map(function() {
        return $(this).data('name');
    }).get();

    export function displayInitialLoad(searchPromise, templates) {
        executeSearch(searchPromise, templates, true);
        updateFilterCountPills();
    }

    export function displayInitialStored(searchPromise, templates) {
        executeStoredSearch(searchPromise, templates, true);
        updateFilterCountPills();
    }

    export function display(searchPromise, templates, focus?: string) {
        executeSearch(searchPromise, templates, false, focus);
        updateFilterCountPills();
    }
    
    export function updateFilterCountPills() {
        let params = GlobalVariables.getParams();
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="remote"]'), (params.RemoteIndicator === undefined || params.RemoteIndicator === null) ? 0 : 1);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="work_type"]'), params.PositionOfferingTypeCode.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="organization"]'), params.Department.length + params.Agency.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="hiring_path"]'), params.HiringPath.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="location"]'), (params.RelocationIndicator ? 1 : 0) + (params.TeleworkIndicator ? 1 : 0) + (params.Radius ? 1 : 0));
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="mcotags"]'), params.MCOTags.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="pay"]'), (params.GradeSearch === true && params.GradeBucket.length > 0) ? 1 : (params.RemunerationMinimumAmount !== undefined ? 1 : 0));
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="position_sensitivity"]'), params.PositionSensitivity.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="security_clearance"]'), params.SecurityClearanceRequired.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="series"]'), params.JobCategoryCode.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="travel_percentage"]'), params.TravelPercentage.length);
        addFilterCountPill(document.querySelector<HTMLElement>('[data-param="work_schedule"]'), params.PositionScheduleTypeCode.length);
    }
    
    function addFilterCountPill(elem: HTMLElement | null, filterCount: number) {
        if (elem === null) {
            return;
        }
        let filterPill = elem.querySelector<HTMLElement>('.rounded-pill');
        if (filterPill !== null) {
            if (filterCount === 0) {
                elem.removeChild(filterPill);
            }
            else {
                filterPill.innerText = filterCount.toString();
            }
        }
        else if (filterCount > 0) {
            filterPill = document.createElement('span');
            filterPill.className = "rounded-pill text-bg-warning";
            filterPill.innerText = filterCount.toString();
            elem.appendChild(filterPill);
        }
    }
    
    function executeSearch(searchPromise, templates, initialLoad: boolean, focus?: string) {
        var params = GlobalVariables.getParams();
        if (JSON.parse(sessionStorage.getItem("userObject") ?? "").IsAuthenticated) {
            reloadUserObject();
        }
        searchPromise.then((data) => {
            $.when(buildResults(data, templates, initialLoad, params)).done(function () {
                if (focus) {
                    $("#" + focus).focus();
                }
            });
        }, (reason) => {
            if (reason !== 'call aborted') {
                GlobalFunctions.errorRedirect();
            }
        });
    }

    function executeStoredSearch(searchPromise, templates, initialLoad: boolean, focus?: string) {
        if (JSON.parse(sessionStorage.getItem("userObject") ?? "").IsAuthenticated) {
            reloadUserObject();
        }
        searchPromise.then((data) => {
            GlobalVariables.parseSavedSearchParams(data.SavedSearchParams);
            let params: Params = URLCriteriaHelper.ParseURL(GlobalVariables.getAliasMapping(), new Params())
            GlobalVariables.setParams(params)
            if (params.Keyword) {
                var temp = decodeURIComponent(params.Keyword.replace(/\+/g, '%20'));
                var keyword = GlobalFunctions.padKeyword(temp);
                if (temp !== keyword) {
                    params.Keyword = keyword;
                }
                $("#nav-keyword").val(keyword);
            }
            $.when(buildResults(data.SearchResult, templates, initialLoad, params)).done(function() {
                if (focus !== null) {
                    $("#" + focus).focus();
                }
            });
        }, (reason) => {
            if (reason !== 'call aborted') {
                GlobalFunctions.errorRedirect();
            }
        });
    }

    function reloadUserObject() {
        var userObject = JSON.parse(sessionStorage.getItem("userObject") ?? "");
        if (new Date().getTime() - 600000 >= userObject.LastLoad) {
            retrieveUserPreferences();
        }
    }

    function buildResults(data, templates, initialLoad: boolean, params: Params) {
        if (data.IsValid) {
            var d = $.Deferred();
            data = DataConversion.convertData(data);
            API.current.Reset();
            data = addSessionProperties(data, initialLoad);
            if (data.ResolvedLocations && params.LocationName.length > 0) {
                params.LocationName = data.ResolvedLocations;
                GlobalVariables.setParams(params);
                URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping(), true);
                $("#only_remote").prop('disabled', true);
                $("#only_remote_msg").attr('rel', "tooltip");
            }
            else {
                $("#only_remote").prop('disabled', false);
                $("#only_remote_msg").attr('rel', "hidden");
            }
            if (params.MCOTags.find(element => element.toString() == "10")) {
                $(".usajobs-search-teaser--infrastructure").css("display", "block");
            }
            if (keywordOrFilter(params, GlobalVariables.getAliasMapping())) {
                $(".usajobs-search-no-params-highlight").addClass("usajobs-hidden");
                var jobCountHtml = templates["jobCountTemplateHtml"](data.Pager);
                $(".usajobs-search-controls__results-count-container").html(jobCountHtml);
                var sortHtml = templates["sortTemplateHtml"](data);
                var sortMobileHtml = templates["sortMobileTemplateHtml"](data);
                $(".usajobs-search-controls__sort-container").html(sortHtml);
                $("#search-sort").html(sortMobileHtml);
                if ($("#sort_attribute").val() === "relevance") {
                    $("#sort_direction_label").hide();
                    $("#sort_direction_attribute").hide();
                }
                if ($("#sort_attribute_mobile").val() === "relevance") {
                    $("#sort_direction_label_mobile").hide();
                    $("#sort_direction_mobile").hide();
                }
                var pagerHtml = templates["pagerTemplateHtml"](data.Pager);
                data.Pager.NumberOfPages > 1 ? $("#paginator").html(pagerHtml) : $("#paginator").html("");
                if (data.Jobs.length > 0) {
                    $("#usajobs-search-results").html(templates["jobCardTemplateHtml"](data));
                    if (data.TeaserName != "") {
                        var insertTeaserIndex = Math.floor(data.Jobs.length / 2),
                            $searchResultItem = $("#usajobs-search-results .usajobs-search-result--core:eq(" + insertTeaserIndex + ")");

                        $searchResultItem.before(templates["teaser-" + data.TeaserName + "-template"]);
                        if (usaj_ga) {
                            usaj_ga.log_event_with_timeout("search teaser", "appear", $('.usajobs-search-teaser').find('a').attr("href"));
                        }
                    }
                    $('#usajobs-search-noresults-searchterms').hide();
                    $('#usajobs-search-noresults-suggestion').hide();
                } else {
                    $("#usajobs-search-results").html(templates["noResultsTemplateHtml"]());
                    $('#usajobs-search-noresults-searchterms').show();
                    $('#usajobs-search-noresults-suggestion').show();
                }
                $(".no-params").removeClass("usajobs-hidden");
                $("#search-tab-bar-sort").prop("disabled", false);
            } else {
                $(".no-params").addClass("usajobs-hidden");
                $(".usajobs-search-no-params-highlight").removeClass("usajobs-hidden");
                $("#search-tab-bar-sort").prop("disabled", true);
            }
            var filterCountHtml = templates["filterCountTemplateHtml"](data.Pager);
            $(".usajobs-search-filter-nav__results").html(filterCountHtml);
            setJumpTo(data.filterData["Department"], "department");
            var departmentHtml = templates["departmentTemplateHtml"]({ Departments: data.filterData["Department"], HasCustomMCOTag: params.CustomMcoTag != null ? true : false });
            $("#department-list-container").html(departmentHtml);
            setJumpTo(data.filterData["Agency"], "agency");
            var agencyHtml = templates["agencyTemplateHtml"]({ Agencies: data.filterData["Agency"], HasCustomMCOTag: params.CustomMcoTag != null ? true : false });
            $("#agency-list-container").html(agencyHtml);
            var seriesJumpHTML = templates["seriesJumpToTemplateHtml"](data.filterData["Series"]);
            $("#series-jump-to-container").html(seriesJumpHTML);
            var seriesFilterHTML = templates["seriesFilterTemplateHtml"](data.filterData["Series"]);
            $("#series-list-container").html(seriesFilterHTML);
            var locationHtml = templates["locationTemplateHtml"](data.f.ri?.relocation??0);
            $("#location-count").html(locationHtml);
            var teleworkHtml = templates["locationTemplateHtml"](data.f.ti?.telework??0);
            $("#telework-count").html(teleworkHtml);
            var onlyRemoteHtml = templates["locationTemplateHtml"](data.f.rmi?.["1"]??0);
            $("#only-remote-count").html(onlyRemoteHtml);
            var excludeRemoteHtml = templates["locationTemplateHtml"](data.f.rmi?.["0"]??0);
            $("#exclude-remote-count").html(excludeRemoteHtml);
            if (params.Keyword != undefined) {
                var searchtermsHTML = templates["searchterms"](formatSearchTerms(params.Keyword));
                $("#usajobs-search-noresults-searchterms").html(searchtermsHTML);
            }
            var suggestionHTML = templates["suggestions"](data.Suggestion);
            $("#usajobs-search-noresults-suggestion").html(suggestionHTML);

            var searchFilters = DataConversion.getSearchFilters();
            for (var i = 0; i < searchFilters.length; i++) {
                var searchFilter = searchFilters[i].FilterType;
                if (!searchFilters[i].Partial) {
                    var filterTemplate: string = searchFilters[i].FilterGroup ? "filterGroupHtml" : "filterItemHtml",
                        filterContentHtml = templates[filterTemplate](data.filterData[searchFilter]);
                    $("#filter-" + searchFilter + "-content").html(filterContentHtml);
                }
            }

            formatSuggestions();
            setBooleanFilters(params);
            GlobalFunctions.buildFilterPills();
            GlobalFunctions.buildLocationPills(data, initialLoad);
            GlobalFunctions.buildStandardOccupationPills();
            GlobalFunctions.buildCyberWorkRolePills();
            GlobalFunctions.buildCyberWorkGroupingPills();
            GlobalFunctions.buildJobTitlePills();
            GlobalFunctions.buildPayPlanPills();
            GlobalVariables.setJobCount(data.Pager.NumberOfItems);
            if (initialLoad) {
                GlobalFunctions.setGrades();
                GlobalFunctions.initSalarySlider();
                setSliderRanges();
                if (GlobalVariables.getProfileFilterCount() > 0) {
                    if (usaj_ga) {
                        usaj_ga.log_event_with_timeout("profile preferences", "appear", location.href);
                    }
                }
            }
            setShowAllFiltersForDisplay();
            for (var i = 0; i < selectAllFilterList.length; i++) {
                resetSelectAllByType(selectAllFilterList[i]);
            }
            if (brandedSearch && $('.usajobs-search-pills__list').find('.usajobs-search-pills__item').not(".usajobs-branded-search-pills").length == 1) {
                $('#search-pills-remove-all').hide();
            }
            $("#usajobs-search-filters").removeClass("is-inactive");
            d.resolve();
        } else {
            //GlobalFunctions.errorRedirect();
        }
    }

    export function errorRedirect() {
        window.location.replace("/Search/SearchError/");
    }

    export function keywordOrFilter(params: Params, aliasMapping) {
        for (var key in params) {
            if (key in aliasMapping && aliasMapping[key].SearchFilter) {
                if (params[key] instanceof Array) {
                    if (params[key].filter(p => p.toString() !== '').length > 0) return true;
                } else if (params[key] !== undefined && params[key] !== null && params[key].toString() !== '') {
                    return true;
                }
            }
        }
        return false;
    }

    export function goToByClassName(className) {
        $('html, body').animate({
            scrollTop: $("." + className).offset()?.top
        }, 'slow');
    }

    export function addSessionProperties(data, initialLoad) {
        let userObject = JSON.parse(sessionStorage.getItem('userObject') ?? "");

        data.IsAuthenticated = userObject && userObject.IsAuthenticated ? true : false;
        if (userObject && userObject.SavedJobs) {
            $.each(data.Jobs, function(i, job) {
                job.IsSaved = job.DocumentID in userObject.SavedJobs ? true : false;
            });
        }

        if (initialLoad) {
            setSavedSearchTemplate(data.IsAuthenticated);
            setProfilePreferencesTemplate(data.IsAuthenticated);
        }

        return data;
    }

    export function addFilterPill(element) {
        if (isIEorEdge()) {
            $(".usajobs-search-pills__list").removeAttr("style");
        }
        var targetID = $(element).attr("id");
        var pillName = $.trim($(element).closest("li").find("label span:not(.icon):eq(0)").text());
        switch (targetID) {
            case "hiring_path-graduates":
                pillName = pillName + " (Hiring path)";
                break;
            case "work_type-15326":
                pillName = pillName + " (Appointment type)";
                break;
            case "work_type-15522":
                pillName = pillName + " (Appointment type)";
                break;
            case "work_schedule-4":
                pillName = pillName + " (Work schedule)";
                break;
            case "work_schedule-6":
                pillName = pillName + " (Work schedule)";
                break;
            case "work_type-15327":
                pillName = pillName + " (Appointment type)";
                break;
            case "security_clearance-0":
                pillName = pillName + " (Security clearance)";
                break;
            case "travel_percentage-0":
                pillName = pillName + " (Travel percentage)";
                break;
        }
        var templateData = {
            target_id: targetID,
            name: pillName,
            property: $(element).attr("name"),
            id: $(element).data("id")
        };
        addPillHtml(templateData);
    }

    export function addPillHtml(data) {
        var filterPillHtml = GlobalVariables.getTemplates()["filterPillHtml"](data);
        var addBrandedSearchClass = false;
        if (brandedSearch) {
            addBrandedSearchClass = checkIfBrandedSearchParam(data);
        }
        $('.usajobs-search-pills__list').prepend(filterPillHtml);
        if (GlobalVariables.getProfilePreferences()[data.target_id] != undefined && GlobalVariables.getProfileRemovedPreferences().indexOf(data.target_id) == -1) {
            var pill = $("#search-pills-" + data.target_id), link = pill.find("a");
            if (!pill.hasClass("usajobs-search-pills__item--profile")) {
                pill.addClass("usajobs-search-pills__item--profile");
                link.attr("title", link.attr("title")?.substring(0, link.attr("title")?.indexOf("filter")) + "profile filter");
            }
        } else if (addBrandedSearchClass) {
            var pill = $("#search-pills-" + data.target_id), link = pill.find("a");
            if (!pill.hasClass("usajobs-branded-search-pills")) {
                pill.addClass("usajobs-branded-search-pills");
                link.attr("title", link.attr("title")?.replace("Remove ", "")!);
                pill.find(".usajobs-search-pills__remove-icon").remove();
            }
        }
        $('#search-pills-remove-all').attr("aria-hidden", "false");
        $('#search-pills-remove-all').show();
        updateMobileFilterCount(true);
    }

    function checkIfBrandedSearchParam(data): boolean {
        if (!data.property) { return false; }
        if (data.property == "series") { data.property = "JobCategoryCode"; }
        if (data.property == "pay") {
            return "" + data.remuneration_max + "" == brandedSearch.RemunerationMaximumAmount && "" + data.remuneration_min + "" == brandedSearch.RemunerationMinimumAmount;
        }
        if (!brandedSearch[data.property]) {
            data.property = gAliasMapping[data.property].JOAQueryName;
        }
        if (brandedSearch[data.property] instanceof Array) {
            return brandedSearch[data.property].includes(data.id) || brandedSearch[data.property].includes("" + data.id + "");
        }

        return brandedSearch[data.property] == data.id || brandedSearch[data.property] == "" + data.id + "";
    }

    export function removeFilterPill(id, callback?) {
        var searchPill = $('#search-pills-' + id);
        if (searchPill.hasClass("usajobs-search-pills__item--profile")) {
            removePreferencePill(id);
        }
        $.when($(searchPill).fadeOut('500')).done(function() {
            $(searchPill).remove();
            hideRemoveAll();
            if (callback !== undefined) {
                callback();
            }
        });
        updateMobileFilterCount(false);
    }

    export function removeFilterPillNoCount(id) {
        var searchPill = $('#search-pills-' + id);
        if (searchPill.hasClass("usajobs-search-pills__item--profile")) {
            removePreferencePill(id);
        }
        $.when($(searchPill).fadeOut('500')).done(function() {
            $(searchPill).remove();
            hideRemoveAll();
        });
    }

    export function removeAllFilters() {
        $.each($('.usajobs-search-pills__list').find('.usajobs-search-pills__item').not(".usajobs-branded-search-pills"), function(i, pill) {
            switch ($(pill).data("target-id")) {
                case "filter-pay":
                case "filter-grade":
                    $("#usajobs-salary-slider").slider("disable");
                    resetSalary(true);
                    break;
                case "filter-distance":
                    removeDistancePill();
                    break;
                case "only_remote":
                    $("#exclude_remote").prop('checked', false);
                    $("#only_remote").prop('checked', false);
                    removeFilterPill($(pill).data('target-id'));
                    break;
                case "exclude_remote":
                    $("#exclude_remote").prop('checked', false);
                    $("#only_remote").prop('checked', false);
                    removeFilterPill($(pill).data('target-id'));
                    break;
                default:
                    removeFilterPill($(pill).data('target-id'));
            }
        });
        $('#search-pills-remove-all').fadeOut('500');
        const params: Params = GlobalVariables.getParams();
        const paramsToKeep = ["Keyword", "SavedSearchID", "SavedSearchName", "GradeSearch"];
        let defaultParams: Params = (brandedSearch) ? DefaultExistingParams(JSON.parse(JSON.stringify(brandedSearch))) : new Params();
        for (var index in paramsToKeep) {
            if (params[paramsToKeep[index]]) {
                defaultParams[paramsToKeep[index]] = params[paramsToKeep[index]];
            }
        }
        defaultParams.ShowAllFilters = params.ShowAllFilters;
        defaultParams.Page = "1";
        $(".usajobs-search-filters__select-toggle").text('Select all');
        GlobalVariables.setParams(defaultParams);
        GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates());
        URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping());
    }

    export function buildFilterPills() {
        var $filters = $('.search-filter-update');
        $.each($filters, function(i, filter) {
            if ($(filter).is(':checked')) {
                var item = $(this).attr('id');
                var checkPill = $("#search-pills-" + item).html();
                if (typeof checkPill === 'undefined' || !checkPill) {
                    GlobalFunctions.addFilterPill($(this));
                }
            }
        });
    }

    export function removePreferencePillsHighlight() {
        $.each($(".usajobs-search-pills__item--profile"), function() {
            $(this).removeClass("usajobs-search-pills__item--profile");
        });
    }
    
    export function addSelections(filterParent: HTMLElement, name: string) {
        $(filterParent).addClass(name);
    }

    export function removeSelections(filterParent: HTMLElement, name: string) {
        $(filterParent).removeClass(name);
    }

    export function removeAllSelections() {
        $('.usa-accordion-button').removeClass("has-selections");
    }

    export function updateMobileFilterCount(increment: boolean) {
        if (increment) {
            GlobalVariables.setFilterCount(GlobalVariables.getFilterCount() + 1);
        } else {
            GlobalVariables.setFilterCount(GlobalVariables.getFilterCount() - 1);
        }
        let filterCount: number = GlobalVariables.getFilterCount();
        let filterLabel: HTMLElement = $("#search-tab-bar-filter-count").get(0)!;
        let filterDisplay: string;
        if (filterCount > 0) {
            filterDisplay = GlobalVariables.getFilterCount().toString();
            $(filterLabel).html(filterDisplay)
            $(filterLabel).parent().attr("aria-hidden", "false");
        } else {
            filterDisplay = "";
            $(filterLabel).html(filterDisplay)
            $(filterLabel).parent().attr("aria-hidden", "true");
        }
    }

    export function formatSalary(total) {
        return '$' + parseFloat(total).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, "$1,").toString();
    }

    export function getSalaryRanges() {
        return [0, 500000];
    }

    export function setGrades() {
        var total = $("#filter-pay-grades .usajobs-search-filter-grades__item").length - 1, count = 0, params = GlobalVariables.getParams(), active_grades:string[] =[];
        if (params.GradeSearch) {
            $("#grade").prop("checked", true);
            $("#filter-pay-grades").attr("data-state", "is-active");
            $(".usajobs-search-filter-grades__grade").each(function() {
                $(this).attr("tabindex", "0");
            });
        }

        $.each($("#filter-pay-grades .usajobs-search-filter-grades__item"), function() {
            var grade = $(this).find(".usajobs-search-filter-grades__grade").attr("data-value");

            if (params.GradeBucket.indexOf(grade!) > -1) {
                $(this).find(".usajobs-search-filter-grades__grade").attr("data-state", "is-active");
                switch (count) {
                    case 0:
                        active_grades.push("<1");
                        break;
                    case total:
                        active_grades.push(">15");
                        break;
                    default:
                        active_grades.push(" " + grade);
                }
            }

            count++;
        });

        if (active_grades.length > 0) {
            $(".usajobs-search-filter-salary__min-GS").text("(min GS" + active_grades[0] + ")");
            $(".usajobs-search-filter-salary__max-GS").text("(max GS" + active_grades[active_grades.length - 1] + ")");
        }
        if (params.GradeBucket.length > 0 && params.GradeSearch) GlobalFunctions.createPillFromGrades();

        if (brandedSearch && brandedSearch.GradeBucket != null && brandedSearch.GradeBucket.length > 0) {
            $('#filter-pay-grades').attr('data-state', 'is-inactive');
            $(".usajobs-search-filter-grades__grade").each(function () {
                $(this).attr("tabindex", "-1");
            });
        }
    }

    export function setSliderRanges() {
        var params = GlobalVariables.getParams(), min = getSalaryRanges()[0], max = getSalaryRanges()[1],
            paramsmin = params.RemunerationMinimumAmount === undefined ? min : parseInt(params.RemunerationMinimumAmount),
            paramsmax = params.RemunerationMaximumAmount === undefined ? max : parseInt(params.RemunerationMaximumAmount);

        $("input[name='pay_filter']").attr({ "data-range-min": min, "data-range-max": max });
        $("#salary-range-min").text(formatSalary(min));
        $("#salary-range-max").text(formatSalary(max));
        if (params.GradeSearch) {
            $("#usajobs-salary-slider").slider("disable");
            $("#usajobs-salary-min").prop("disabled", true);
            $("#usajobs-salary-max").prop("disabled", true);
        }
        if ((paramsmin !== min || paramsmax !== max) && !params.GradeSearch) {
            GlobalFunctions.createPillFromPay();
        }
    }

    export function createPillFromPay() {
        var $pay_pill = $("#search-pills-filter-pay"),
            id = "filter-pay",
            min_amount = $("#usajobs-salary-min").val(),
            max_amount = $("#usajobs-salary-max").val(),
            text = min_amount + " - " + max_amount;

        if ($pay_pill !== undefined && $pay_pill.length > 0) {
            $pay_pill
                .find(".search-pill-name")
                .text(text);
        } else {
            var params: Params = GlobalVariables.getParams();
            addPillHtml({ target_id: id, name: text, remuneration_min: params.RemunerationMinimumAmount, remuneration_max: params.RemunerationMaximumAmount, property: "pay" });
            $("#search-pills-filter-pay").attr("data-behavior", "search-pills.salary-reset");
        }
    }

    export function createPillFromGrades() {
        var $grade_pill = $("#search-pills-filter-grade"),
            grade_min_max = findGradeMinMax(),
            id = "filter-grade",
            text;

        if (grade_min_max.min === 0) {
            grade_min_max.min = "<1";
        } else if (grade_min_max.min === 16) {
            grade_min_max.min = ">15";
        }

        if (grade_min_max.max === 16) {
            grade_min_max.max = ">15";
        } else if (grade_min_max.max === 0) {
            grade_min_max.max = "<1";
        }

        if (grade_min_max.min === grade_min_max.max) {
            text = "GS " + grade_min_max.min;
        } else {
            text = "GS " + grade_min_max.min + " - GS " + grade_min_max.max;
        }

        if ($grade_pill !== undefined && $grade_pill.length > 0) {
            $grade_pill.find(".search-pill-name").text(text);
        } else {
            addPillHtml({ target_id: id, name: text, property: "grade", id: grade_min_max.min });
            $("#search-pills-filter-grade").attr("data-behavior", "search-pills.grade-reset");
        }
    }

    export function findGradeMinMax() {
        var $grade_table = $("#filter-pay-grades"),
            $active_grades = $grade_table.find("[data-state='is-active']"),
            active_grades:number[] = [],
            min_grade,
            max_grade;

        $.each($active_grades, function(idx, grade) {
            active_grades.push(parseInt($(grade).attr("data-value")!));
        });

        if (active_grades !== undefined && active_grades.length > 0) {
            min_grade = Math.min.apply(null, active_grades);
            max_grade = Math.max.apply(null, active_grades);
        }

        if (isNaN(min_grade) || min_grade === "") {
            min_grade = 1;
        }

        if (isNaN(max_grade) || max_grade === "") {
            max_grade = 15;
        }

        return {
            min: min_grade,
            max: max_grade
        };
    }
    export function resetRemote() {
        $("#only_remote").prop('checked', false);
        $("#exclude_remote").prop('checked', false);
        var params = GlobalVariables.getParams();
        delete params.RemoteIndicator;
        GlobalVariables.setParams(params);
        GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates());
        URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping());
        GlobalFunctions.removeFilterPill("only_remote");
        GlobalFunctions.removeFilterPill("exclude_remote");

    }

    export function resetSalary(removeAll: boolean = false, focus?: string) {
        var min = getSalaryRanges()[0], max = getSalaryRanges()[1];

        resetGrades();
        if ($("#search-pills-filter-pay").length > 0) removeFilterPill("filter-pay");
        var params = GlobalVariables.getParams();
        delete params.RemunerationMinimumAmount;
        delete params.RemunerationMaximumAmount;
        params.Page = "1";
        GlobalVariables.setParams(params);
        $("#usajobs-salary-slider").slider("option", "values", [min, max]);
        $("#usajobs-salary-min").val(formatSalary(min));
        $("#usajobs-salary-max").val(formatSalary(max));
        if (!removeAll) {
            GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates(), focus);
            URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping());
        }
    }

    export function resetGrades() {
        var $grades = $(".usajobs-search-filter-grades__grade"),
            $grade;

        $.each($grades, function(idx, grade) {
            $grade = $(grade);
            $grade.attr("data-state", "is-inactive");
        });
        
        if ($("#search-pills-filter-grade").length > 0) removeFilterPill("filter-grade");

        var params = GlobalVariables.getParams();
        params.GradeBucket = [];
        GlobalVariables.setParams(params);
    }

    export function validateMinAndMax(field) {
        var $input_min = $("#usajobs-salary-min"), $input_max = $("#usajobs-salary-max"), min_range = getSalaryRanges()[0], max_range = getSalaryRanges()[1];
        var min = parseInt(($input_min.val() as string).replace(/\D/g, ''), 10);
        var max = parseInt(($input_max.val() as string).replace(/\D/g, ''), 10);

        if (isNaN(min)) {
            min = min_range;
        }

        if (isNaN(max)) {
            max = max_range;
        }

        if (field === "min") {
            if (min < min_range) {
                min = min_range;
            }

            if (min > max) {
                max = max_range;
            }
        }

        if (field === "max") {
            if (max > max_range) {
                max = max_range;
            }

            if (max < min) {
                min = min_range;
            }
        }

        $input_min.val(formatSalary(min));
        $input_max.val(formatSalary(max));
    };

    export function initSalarySlider() {
        var min_range = getSalaryRanges()[0],
            max_range = getSalaryRanges()[1],
            min_value,
            max_value,
            $input_min = $("#usajobs-salary-min"),
            $input_max = $("#usajobs-salary-max"),
            $slider_min = $('#usajobs-salary-handle-min'),
            $slider_max = $('#usajobs-salary-handle-max');

        var params = GlobalVariables.getParams();
        if (params.RemunerationMinimumAmount && params.RemunerationMaximumAmount) {
            min_value = params.RemunerationMinimumAmount, max_value = params.RemunerationMaximumAmount;
        }
        
        if (min_value === undefined) {
            min_value = min_range;
        } else {
            min_value = min_value.toString().replace(/\D/g, '');
        }

        if (max_value === undefined) {
            max_value = max_range;
        } else {
            max_value = max_value.toString().replace(/\D/g, '');
        }

        if (min_value < min_range) {
            min_value = min_range;
        }

        if (max_value > max_range) {
            max_value = max_range;
        }

        $("#usajobs-salary-slider").slider({
            range: true,
            min: min_range,
            max: max_range,
            step: 10,
            values: [min_value, max_value],
            create: function (event, ui) {
                $input_min.val(formatSalary(min_value));
                $input_max.val(formatSalary(max_value));
                $slider_min.attr('aria-valuemin', min_value);
                $slider_min.attr('aria-valuemax', max_value);
                $slider_min.attr('aria-valuenow', min_value);
                $slider_max.attr('aria-valuemin', min_value);
                $slider_max.attr('aria-valuemax', max_value);
                $slider_max.attr('aria-valuenow', max_value);
            },
            slide: function (event, ui) {
                if (ui.values && ui.values.length > 0) {
                    $slider_min.attr('aria-valuenow', ui.values[0]);
                    $slider_max.attr('aria-valuenow', ui.values[1]);
                    $("#usajobs-salary-min").val(formatSalary(ui.values[0]));
                    $("#usajobs-salary-max").val(formatSalary(ui.values[1]));
                }                
            },
            change: debounce(function(event, ui) {
                if ($("#salary").is(":checked") && !$("#usajobs-salary-slider").slider("option", "disabled")) {
                    var params = GlobalVariables.getParams();
                    params.Page = "1";
                    if (ui.values[0] === min_range && ui.values[1] === max_range) {
                        GlobalFunctions.removeFilterPill("filter-pay");
                        delete params.RemunerationMinimumAmount;
                        delete params.RemunerationMaximumAmount;
                    } else {
                        GlobalFunctions.createPillFromPay();
                        params.RemunerationMinimumAmount = ($("#usajobs-salary-min").val() as string).replace(/\D/g, '');
                        params.RemunerationMaximumAmount = ($("#usajobs-salary-max").val() as string).replace(/\D/g, '');
                    }
                    GlobalVariables.setParams(params);
                    GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates());
                    URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping());
                }
                if ($("#salary").is(":checked")) $("#usajobs-salary-slider").slider("enable");
            }, 300)
        });

        if (brandedSearch && (brandedSearch.RemunerationMaximumAmount || brandedSearch.RemunerationMinimumAmount)) {
            $("#usajobs-salary-slider").slider("disable");
            $("#usajobs-salary-min").prop("disabled", true);
            $("#usajobs-salary-max").prop("disabled", true);
            $("#salary-reset").hide();
        }
    }

    export function debounce(func, wait, immediate = false) {
        var timeout;
        return function(this:any) {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    export function selectAllFiltersByType(filter, params) {
        $("input[name='" + filter + "']").each(function(index) {
            if ($(this).is(":visible") && $(this).is(':checkbox')) {
                if (filter === "work_schedule") {
                    if (!$(this).is(":checked")) {
                        removeFilterPillNoCount(filter + '-' + $(this).data('id'));
                        params.PositionScheduleTypeCode.push($(this).data('id'));
                        let filterParent: HTMLElement = $("[aria-controls='filter-work_schedule']").get(0)!;
                        GlobalFunctions.addSelections(filterParent, "has-selections");
                    }
                }
                else if (filter === "work_type") {
                    if (!$(this).is(":checked")) {
                        removeFilterPillNoCount('work_type-' + $(this).data('id'));
                        params.PositionOfferingTypeCode.push($(this).data('id'));
                        let filterParent: HTMLElement = $("[aria-controls='filter-appointment_type']").get(0)!;
                        GlobalFunctions.addSelections(filterParent, "has-selections");
                    }
                }
                else if (filter === "security_clearance") {
                    if (!$(this).is(":checked")) {
                        removeFilterPillNoCount(filter + '-' + $(this).data('id'));
                        params.SecurityClearanceRequired.push($(this).data('id'));
                        let filterParent: HTMLElement = $("[aria-controls='filter-security_clearance']").get(0)!;
                        GlobalFunctions.addSelections(filterParent, "has-selections");
                    }
                }
                else if (filter === "position_sensitivity") {
                    if (!$(this).is(":checked")) {
                        removeFilterPillNoCount(filter + '-' + $(this).data('id'));
                        params.PositionSensitivity.push($(this).data('id'));
                        let filterParent: HTMLElement = $("[aria-controls='filter-position_sensitivity']").get(0)!;
                        GlobalFunctions.addSelections(filterParent, "has-selections");
                    }
                }
                else if (filter === "travel_percentage") {
                    if (!$(this).is(":checked")) {
                        removeFilterPillNoCount(filter + '-' + $(this).data('id'));
                        params.TravelPercentage.push($(this).data('id'));
                        let filterParent: HTMLElement = $("[aria-controls='filter-travel_percentage']").get(0)!;
                        GlobalFunctions.addSelections(filterParent, "has-selections");
                    }
                }
                else if (filter === "hiring_path") {
                    if (!$(this).is(":checked")) {
                        removeFilterPillNoCount(filter + '-' + $(this).data('id'));
                        params.HiringPath.push($(this).data('id'));
                        let filterParent: HTMLElement = $("[aria-controls='filter-hiring_paths']").get(0)!;
                        GlobalFunctions.addSelections(filterParent, "has-selections");
                    }
                }
                else if (filter === "mcotags") {
                    if (!$(this).is(":checked")) {
                        removeFilterPillNoCount(filter + '-' + $(this).data('id'));
                        params.MCOTags.push($(this).data('id').toString());
                        let filterParent: HTMLElement = $("[aria-controls='filter-mcotags']").get(0)!;
                        GlobalFunctions.addSelections(filterParent, "has-selections");
                    }
                }                
            }
        });
    }

    export function deselectAllFiltersByType(filter, params) {
        $("input[name='" + filter + "']").each(function(index) {
            if ($(this).is(":visible") && $(this).is(':checkbox')) {
                if (filter === "work_schedule") {
                    for (var i = 0; i < params.PositionScheduleTypeCode.length; i++) {
                        removeFilterPill(filter + '-' + params.PositionScheduleTypeCode[i]);
                    }
                    params.PositionScheduleTypeCode = [];
                    let filterParent: HTMLElement = $("[aria-controls='filter-work_schedule']").get(0)!;
                    GlobalFunctions.removeSelections(filterParent, "has-selections");
                }
                else if (filter === "work_type") {
                    for (var i = 0; i < params.PositionOfferingTypeCode.length; i++) {
                        removeFilterPill('work_type-' + params.PositionOfferingTypeCode[i]);
                    }
                    params.PositionOfferingTypeCode = [];
                    let filterParent: HTMLElement = $("[aria-controls='filter-appointment_type']").get(0)!;
                    GlobalFunctions.removeSelections(filterParent, "has-selections");
                }
                else if (filter === "security_clearance") {
                    for (var i = 0; i < params.SecurityClearanceRequired.length; i++) {
                        removeFilterPill(filter + '-' + params.SecurityClearanceRequired[i]);
                    }
                    params.SecurityClearanceRequired = [];
                    let filterParent: HTMLElement = $("[aria-controls='filter-security_clearance']").get(0)!;
                    GlobalFunctions.removeSelections(filterParent, "has-selections");
                }
                else if (filter === "position_sensitivity") {
                    for (var i = 0; i < params.PositionSensitivity.length; i++) {
                        removeFilterPill(filter + '-' + params.PositionSensitivity[i]);
                    }
                    params.PositionSensitivity = [];
                    let filterParent: HTMLElement = $("[aria-controls='filter-position_sensitivity']").get(0)!;
                    GlobalFunctions.removeSelections(filterParent, "has-selections");
                }
                else if (filter === "travel_percentage") {
                    for (var i = 0; i < params.TravelPercentage.length; i++) {
                        removeFilterPill(filter + '-' + params.TravelPercentage[i]);
                    }
                    params.TravelPercentage = [];
                    let filterParent: HTMLElement = $("[aria-controls='filter-travel_percentage']").get(0)!;
                    GlobalFunctions.removeSelections(filterParent, "has-selections");
                }
                else if (filter === "hiring_path") {
                    for (var i = 0; i < params.HiringPath.length; i++) {
                        removeFilterPill(filter + '-' + params.HiringPath[i]);
                    }
                    params.HiringPath = [];
                    let filterParent: HTMLElement = $("[aria-controls='filter-hiring_paths']").get(0)!;
                    GlobalFunctions.removeSelections(filterParent, "has-selections");
                }
                else if (filter === "mcotags") {
                    for (var i = 0; i < params.MCOTags.length; i++) {
                        removeFilterPill(filter + '-' + params.MCOTags[i]);
                    }
                    params.MCOTags = [];
                    let filterParent: HTMLElement = $("[aria-controls='filter-mcotags']").get(0)!;
                    GlobalFunctions.removeSelections(filterParent, "has-selections");
                }
            }
        });
    }

    export function resetSelectAllByType(filter) {
        var totalCheckboxes = 0;
        var selectedCheckboxes = $('input[name=' + filter + ']:checked').length;
        var linkText = $('[data-name="' + filter + '"]').text().trim();
        var aliasMapping = GlobalVariables.getAliasMapping();
        $('input[name=' + filter + ']').each(function(index) {
            if (!($(this).parent().css('display') == 'none')) {
                totalCheckboxes++;
            }
        });
        if (brandedSearch && brandedSearch[aliasMapping[filter]?.JOAQueryName]) {
            $('[data-name="' + filter + '"]').hide();
        }
        else if (totalCheckboxes == 0) {
            $('[data-name="' + filter + '"]').hide();
        }
        else if (linkText == "Deselect all") {
            $('[data-name="' + filter + '"]').show();
            if (selectedCheckboxes < totalCheckboxes) {
                $('[data-name="' + filter + '"]').text('Select all');
            }
        }
        else {
            if (totalCheckboxes == selectedCheckboxes) {
                $('[data-name="' + filter + '"]').show();
                $('[data-name="' + filter + '"]').text('Deselect all');
            }
        }
    }

    export function setBooleanFilters(params: Params) {
        if (params.RelocationIndicator === "true" || params.RelocationIndicator) {
            $("input[name='relocation']").prop('checked', true);
        }
        else {
            $("input[name='relocation']").prop('checked', false);
        }
        if (params.TeleworkIndicator === "true" || params.TeleworkIndicator) {
            $("input[name='telework']").prop('checked', true);
        }
        else {
            $("input[name='telework']").prop('checked', false);
        }
        if (params.RemoteIndicator === "true" || params.RemoteIndicator == true) {
            $("#only_remote").prop('checked', true);
        }
        if (params.RemoteIndicator === "false" || params.RemoteIndicator == false) {
            $("#exclude_remote").prop('checked', true);
        }        
    }

    export function setShowAllFiltersForDisplay() {
        var params = GlobalVariables.getParams();
        for (var i = 0; i < params.ShowAllFilters.length; i++) {
            var ele = $('.usajobs-search-filters__show-all-options[data-id="' + params.ShowAllFilters[i] + '"]');
            $.each($(ele).closest("div").find(".usajobs-search-filters__list"), function(index, key) {
                var header = $(ele).closest("div").find(".usajobs-search-refiner__letter");
                if (header.length && header.hasClass("usaj-zero-jobs")) {
                    header.removeClass("usajobs-hidden");
                }
                $.each($(ele).closest("div").find(".usajobs-search-filters__item"), function(index, value) {
                    if ($(this).hasClass("usaj-zero-jobs")) {
                        $(this).removeClass("usajobs-hidden");
                    }
                });

                if (params.ShowAllFilters[i] == "dep" || params.ShowAllFilters[i] == "ag") {
                    var agencyGroupID = $(this).prev(".usajobs-search-refiner__letter").data('id');
                    $('.usajobs-search-refiner__jump-letter[data-id="' + agencyGroupID + '"]').removeClass('usajobs-search-link-disabled');
                }

                if (params.ShowAllFilters[i] == "ser") {
                    var seriesGroupID = $(this).closest("div").find(".usajobs-search-refiner__number").data('id');
                    $('.usajobs-search-refiner__jump-number[data-id="' + seriesGroupID + '"]').removeClass('usajobs-search-link-disabled');
                    $(".usajobs-search-filters-group").each(function(index) {
                        if ($(this).hasClass("usaj-zero-jobs")) {
                            var seriesGroupID = $(this).children(".usajobs-search-refiner__number").data('id');
                            $(this).removeClass("usajobs-hidden");
                            $('.usajobs-search-refiner__jump-number[data-id="' + seriesGroupID + '"]').removeClass('usajobs-search-link-disabled');
                        }
                    });
                }
                let $returnToTopLink = $(key).next('a.usaj-zero-jobs');
                $returnToTopLink.css('display', '');
            });
            $(ele).text("Hide options with 0 jobs");
        }
    }

    export function setSavedSearchTemplate(authenticated: boolean) {
        let templates = GlobalVariables.getTemplates();
        let savedSearchTemplate: string;
        if (authenticated) {
            let savedSearchParams: string = GlobalVariables.getSavedSearchParams();
            let params: Params = savedSearchParams ? JSON.parse(savedSearchParams) : null;
            if (params && params.SavedSearchID) {
                var source = { IsEdit: true, SearchName: params.SavedSearchName };
                var savedSearchTemplateHTML = templates["savedSearchSignedIn"](source);
                $("#ss-container").html(savedSearchTemplateHTML);
            } else {
                var source2 = { IsEdit: false, SearchName: "" };
                var savedSearchTemplateHTML = templates["savedSearchSignedIn"](source2);
                $("#ss-container").html(savedSearchTemplateHTML);
            }
        } else {
            savedSearchTemplate = templates["savedSearchNonSignedIn"](null);
            $('#search-save-n').html(savedSearchTemplate);
            $('#usajobs-save-search').removeClass("usaj-hidden");
        }
    }

    export function setProfilePreferencesTemplate(authenticated: boolean) {
        let templates = GlobalVariables.getTemplates();
        if (!brandedSearch) {
            if (authenticated) {
                var source = { FilterCount: GlobalVariables.getProfileFilterCount(), IsActive: sessionStorage.getItem("profilePreferences") };
                let savedSearchTemplate: string = templates["profilePreferencesSignedIn"](source);
                $("#search-prefs").html(savedSearchTemplate);
            } else {
                let savedSearchTemplate: string = templates["profilePreferencesNotSignedIn"](null);
                $("#search-prefs").html(savedSearchTemplate);
            }
        }
    }

    export function enableSalary() {
        $("#usajobs-salary-slider").slider("enable");
        $("#usajobs-salary-min").prop("disabled", false);
        $("#usajobs-salary-max").prop("disabled", false);
        var min = parseInt(($("#usajobs-salary-min").val() as string).replace(/\D/g, '')), max = parseInt(($("#usajobs-salary-max").val() as string).replace(/\D/g, '')),
            minrange = getSalaryRanges()[0], maxrange = getSalaryRanges()[1];

        var params = GlobalVariables.getParams();
        params.GradeSearch = false;

        if (min !== 0 && max !== maxrange) {
            GlobalFunctions.createPillFromPay();
        }

        GlobalVariables.setParams(params);
        GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates(), "salary");
        URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping());
    }

    export function disableSalary() {
        $("#usajobs-salary-slider").slider("disable");
        $("#usajobs-salary-min").prop("disabled", true);
        $("#usajobs-salary-max").prop("disabled", true);
        GlobalFunctions.removeFilterPill("filter-pay");
    }

    export function enableGrades() {
        $('#filter-pay-grades').attr('data-state', 'is-active');
        $(".usajobs-search-filter-grades__grade").each(function() {
            $(this).attr("tabindex", "0");
        });
        var params = GlobalVariables.getParams();
        params.GradeSearch = true;
        if (params.GradeBucket.length > 0) {
            GlobalFunctions.createPillFromGrades();
        }

        GlobalVariables.setParams(params);
        GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates(), "grade");
        URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping());
    }

    export function disableGrades() {
        $('#filter-pay-grades').attr('data-state', 'is-inactive');
        $(".usajobs-search-filter-grades__grade").each(function() {
            $(this).attr("tabindex", "-1");
        });
        GlobalFunctions.removeFilterPill("filter-grade");
    }

    export function getRadiusRanges() {
        //[min, max, default]
        return [0, 200, 25];
    }

    export function validateRadius() {
        var min_range = getRadiusRanges()[0],
            max_range = getRadiusRanges()[1],
            default_distance = getRadiusRanges()[2],
            $radius = $("#usajobs-radius-min"),
            radius_value = parseInt(($radius.val() as string).replace(/\D/g, ''), 10);

        if (isNaN(radius_value)) {
            radius_value = default_distance;
        }

        if ((radius_value < min_range) || radius_value > max_range) {
            radius_value = default_distance;
        }

        $radius.val(radius_value);
    }

    export function resetDistance() {
        var default_distance = getRadiusRanges()[0];
        $('#usajobs-radius-min').val(default_distance);
        $('#usajobs-radius-slider').slider("value", default_distance);
    }

    export function removeDistancePill() {
        GlobalFunctions.removeFilterPill("filter-distance");
        setDistanceSlider(getRadiusRanges()[2]);
    }

    export function setDistanceSlider(distance) {
        $('#usajobs-radius-slider').slider("disable");
        $('#usajobs-radius-min').val(distance);
        $('#usajobs-radius-slider').slider("value", distance);
        $('#usajobs-radius-slider').slider("enable");
    }

    export function getRadius() {
        var params = GlobalVariables.getParams();
        return params.Radius !== undefined ? parseInt(params.Radius) : getRadiusRanges()[2];
    }

    export function initRadiusSlider() {
        var min_range = getRadiusRanges()[0],
            max_range = getRadiusRanges()[1],
            radius;

        $('#usajobs-radius-min').val(radius);

        $('#usajobs-radius-slider').slider({
            range: 'min',
            min: min_range,
            max: max_range,
            step: 5,
            value: radius,
            slide: function(event, ui) {
                $('#usajobs-radius-min').val(ui.value ?? "");
            },
            change: function(event) {
                if (!$('#usajobs-radius-slider').slider("option", "disabled")) {
                    createPillFromDistance();
                    var params = GlobalVariables.getParams();
                    params.Page = "1";
                    params.Radius = $('#usajobs-radius-min').val() as string;
                    GlobalVariables.setParams(params);
                    GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates());
                    URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping());
                }
            }
        });
    }

    export function createPillFromDistance() {
        var distance_pill = $("#search-pills-filter-distance"),
            params = GlobalVariables.getParams(),
            id = "filter-distance",
            text;

        text = $("#usajobs-radius-min").val() + " miles";

        if (distance_pill !== undefined && distance_pill.length > 0) {
            distance_pill.find(".search-pill-name").text(text);
        } else {
            addPillHtml({ target_id: id, name: text });
            $("#search-pills-filter-distance").attr("data-behavior", "search-pills.distance-reset");
        }
    }

    export function buildLocationPills(data, initialLoad) {
        var params = GlobalVariables.getParams();
        for (var i = 0; i < params.LocationName.length; i++) {
            if (params.LocationName[i]) {
                var targetID = "loc_" + replaceAllSpecialChars(params.LocationName[i].replace(/ /g, "-"), ",", "-");
                var existing = $('[data-target-id="' + targetID + '"]').text().trim();
                if (!existing) {
                    addPillHtml({
                        target_id: targetID,
                        name: params.LocationName[i],
                        property: "LocationName",
                        id: params.LocationName[i]
                    });
                }
            }
        }
        if (initialLoad) {
            initRadiusSlider();
        }
        if (data.IsRadialSearch) {
            setDistanceSlider(getRadius());
            createPillFromDistance();
            $("#filter-location-content").find(".usajobs-search-filters__list").children().first().show();
        } else {
            $("#filter-location-content").find(".usajobs-search-filters__list").children().first().hide();
            if ($("#search-pills-filter-distance").length > 0) removeDistancePill();
        }
    }

    export function addLocationPill(location) {
        var targetID = "loc_" + replaceAllSpecialChars(location.replace(/ /g, "-"), ",", "-");
        addPillHtml({ target_id: targetID, name: location });
    }

    export function buildStandardOccupationPills() {
        var params: Params = GlobalVariables.getParams();
        for (var i = 0; i < params.SocTitle.length; i++) {
            var targetID = "soc_" + replaceAllSpecialChars(params.SocTitle[i].replace(/ /g, "-"), ",", "-");
            var existing = $('[data-target-id="' + targetID + '"]').text().trim();
            if (!existing) {
                addPillHtml({ target_id: targetID, name: params.SocTitle[i] });
            }
        }
    }

    export function buildCyberWorkRolePills() {
        var params: Params = GlobalVariables.getParams();
        for (var i = 0; i < params.CyberWorkRole.length; i++) {
            var targetID = "cwr_" + replaceAllSpecialChars(params.CyberWorkRole[i].replace(/ /g, "-"), ",", "-");
            var existing = $('[data-target-id="' + targetID + '"]').text().trim();
            if (!existing) {
                addPillHtml({ target_id: targetID, name: DataConversion.getCyberWorkRoleByCode(params.CyberWorkRole[i]), id: params.CyberWorkRole[i], property: "CyberWorkRole" });
            }
        }
    }
    export function buildCyberWorkGroupingPills() {
        var params: Params = GlobalVariables.getParams();
        for (var i = 0; i < params.CyberWorkGrouping.length; i++) {
            var targetID = "cwg_" + replaceAllSpecialChars(params.CyberWorkGrouping[i].replace(/ /g, "-"), ",", "-");
            var existing = $('[data-target-id="' + targetID + '"]').text().trim();
            if (!existing) {
                addPillHtml({ target_id: targetID, name: DataConversion.getCyberWorkGroupingByCode(params.CyberWorkGrouping[i]) });
            }
        }
    }
    export function buildPayPlanPills() {
        var params: Params = GlobalVariables.getParams();
        for (var i = 0; i < params.JobGradeCode.length; i++) {
            var targetID = "pp_" + replaceAllSpecialChars(params.JobGradeCode[i].replace(/ /g, "-"), ",", "-");
            var existing = $('[data-target-id="' + targetID + '"]').text().trim();
            if (!existing) {
                addPillHtml({ target_id: targetID, name: DataConversion.getPayPlanByJobGradeCode(params.JobGradeCode[i]), property: 'JobGradeCode', id: params.JobGradeCode[i] });
            }
        }
    }
    export function buildJobTitlePills() {
        var params = GlobalVariables.getParams();
        for (var i = 0; i < params.JobTitle.length; i++) {
            var targetID = "jt_" + replaceAllSpecialChars(params.JobTitle[i].replace(/ /g, "-"), ",", "-");
            var existing = $('[data-target-id="' + targetID + '"]').text().trim();
            if (!existing) {
                addPillHtml({ target_id: targetID, name: params.JobTitle[i] });
            }
        }
    }

    export function formatSearchTerms(search) {
        var terms = search.split(' ');
        if (terms.length == 0) {
            return '';
        } else if (terms.length == 1) {
            return terms[0];
        } else {
            let last = terms.pop();
            return terms.join(', ') + ', and ' + last;
        }
    }

    export function formatSuggestions() {
        var sugg = $(".suggest-comma");
        if (sugg)
            sugg.last().text('');
    }

    export function checkCandidateEligibility() {
        let userObject = JSON.parse(sessionStorage.getItem('userObject') ?? "");
        let IsAuthenticated: boolean = userObject && userObject.IsAuthenticated ? true : false;
        let params: Params = GlobalVariables.getParams();
        let savedSearchID: number | undefined = params.SavedSearchID;
        let prefs: { [id: string]: Preference; } = {};
        let filterCount: number = 0;
        let prefsToggle = sessionStorage.getItem("profilePreferences");
        let removedPrefs = GlobalVariables.getProfileRemovedPreferences();
        if (userObject && IsAuthenticated && !savedSearchID) {
            for (let i = 0; i < userObject.HiringPaths.length; i++) {
                var code = userObject.HiringPaths[i].Code;
                if (prefsToggle !== "false") {
                    params.HiringPath.push(code);
                } else if (prefsToggle === "false") {
                    removedPrefs.push(`hiring_path-${code}`);
                }
                prefs[`hiring_path-${code}`] = new Preference("HiringPath", code);
                filterCount++
            }

            if (userObject.Eligibility?.WantsRelocation == true) {
                if (prefsToggle !== "false") {
                    params.RelocationIndicator = true;
                    prefs["relocation_assistance"] = new Preference("RelocationIndicator", "true");
                } else if (prefsToggle === "false") {
                    removedPrefs["relocation_assistance"];
                }
                filterCount++
            }

            if (userObject.Eligibility?.WantsTelework == true) {
                if (prefsToggle !== "false") {
                    params.TeleworkIndicator = true;
                    prefs["telework_eligible"] = new Preference("TeleworkIndicator", "true");
                } else if (prefsToggle === "false") {
                    removedPrefs["telework_eligible"];
                }
                filterCount++
            }

            if (userObject.Preferences.PositionOfferings.length > 0) {
                var offerings = userObject.Preferences.PositionOfferings;
                for (var x = 0; x < offerings.length; x++) {
                    if (offerings[x] === '15669') {
                        prefs["telework_eligible"] = new Preference("TeleworkIndicator", true);
                    }
                    if (prefsToggle !== "false" && $.inArray(offerings[x], params.PositionOfferingTypeCode) == -1) {
                        if (offerings[x] === '15669') {
                            params.TeleworkIndicator = true;
                            removedPrefs.push("work_type-" + offerings[x]);
                        }
                        else {
                            params.PositionOfferingTypeCode.push(offerings[x]);
                            prefs["work_type-" + offerings[x]] = new Preference("WorkType", offerings[x]);
                        }
                    } else if (prefsToggle === "false") {
                        removedPrefs.push("work_type-" + offerings[x]);
                        prefs["work_type-" + offerings[x]] = new Preference("WorkType", offerings[x]);
                    }
                    filterCount++;
                }
            }
            if (userObject.Preferences.PositionSchedules.length > 0) {
                var schedules = userObject.Preferences.PositionSchedules;
                for (var x = 0; x < schedules.length; x++) {
                    if (prefsToggle !== "false" && $.inArray(schedules[x], params.PositionScheduleTypeCode) == -1) {
                        params.PositionScheduleTypeCode.push(schedules[x]);
                    } else if (prefsToggle === "false") {
                        removedPrefs.push("work_schedule-" + schedules[x]);
                    }
                    prefs["work_schedule-" + schedules[x]] = new Preference("WorkSchedule", schedules[x]);
                    filterCount++;
                }
            }
            if (userObject.Preferences.TravelPercentage.length > 0) {
                var travel = userObject.Preferences.TravelPercentage;
                for (var x = 0; x < travel.length; x++) {
                    if (prefsToggle !== "false" && $.inArray(travel[x], params.TravelPercentage) == -1) {
                        params.TravelPercentage.push(travel[x]);
                    } else if (prefsToggle === "false") {
                        removedPrefs.push("travel_percentage-" + travel[x]);
                    }
                    prefs["travel_percentage-" + travel[x]] = new Preference("TravelPercentage", travel[x]);
                    filterCount++;
                }
            }
            if (userObject.Preferences.DesiredLocations.length > 0) {
                var locations = userObject.Preferences.DesiredLocations;
                for (var x = 0; x < locations.length; x++) {
                    var id = locations[x].replace(/,| /g, '-');
                    if (prefsToggle !== "false" && $.inArray(locations[x], params.LocationName) == -1) {
                        params.LocationName.push(locations[x]);
                    } else if (prefsToggle === "false") {
                        removedPrefs.push("loc_" + id);
                    }
                    prefs["loc_" + id] = new Preference("Location", locations[x]);
                    filterCount++;
                }
            }
            if (IsAuthenticated && filterCount === 0) {
                $("#no-profile-preferences-alert").removeClass("usaj-hidden");
            }
            if (IsAuthenticated && !userObject.Eligibility.ProfileUpToDate) {
                $("#profile-preferences-date-alert").removeClass("usaj-hidden");
            }
            
            GlobalVariables.setProfilePreferences(prefs);
            GlobalVariables.setProfileFilterCount(filterCount);
            GlobalVariables.setProfileRemovedPreferences(removedPrefs);
            if (prefsToggle !== "false") {
                URLCriteriaHelper.ConstructURL(params, GlobalVariables.getAliasMapping(), true);
            }
        }
        if (savedSearchID) {
            $("#search-prefs").addClass("usajobs-hidden");
        }
    }

    export function replaceAllSpecialChars(input, find, replace) {
        return input.replace(/[^a-zA-Z0-9 ]/g, replace);
    }

    export function padKeyword(keyword) {
        if (keyword !== "" && !isNaN(keyword) && keyword.length < 4) {
            for (var x = keyword.length; x < 4; x++) {
                keyword = "0" + keyword;
            }
        }
        return keyword;
    }

    export function setJumpTo(groups, type) {
        var count = 0, maxCount = groups.length - 1;
        for (var i = 0; i < groups.length; i++) {
            if (isNaN(groups[count].Group)) {
                break;
            } else {
                count++;
            }
        }
        $.each($("#filter-" + type + "-jump-list li"), function() {
            var letter = $(this).find("a");
            if (letter.attr("data-id") === groups[count].Group) {
                if (groups[count].ShowGroup) {
                    letter.removeClass("usajobs-search-link-disabled");
                } else {
                    letter.addClass("usajobs-search-link-disabled");
                }
                if (count < maxCount) count++;
            } else {
                letter.addClass("usajobs-search-link-disabled");
            }
        });
    }

    export function removePreferencePills() {
        var prefs = GlobalVariables.getProfilePreferences();
        var removedPrefs = GlobalVariables.getProfileRemovedPreferences();
        var params = GlobalVariables.getParams();
        params.Page = "1";
        for (var pref in prefs) {
            if (removedPrefs.indexOf(pref) == -1) {
                removeFilterPill(pref);
                switch (prefs[pref].Type) {
                    case "HiringPath":
                        params.HiringPath.splice(params.HiringPath.indexOf(prefs[pref].Value.toString()), 1);
                        break;
                    case "TravelPercentage":
                        params.TravelPercentage.splice(params.TravelPercentage.indexOf(prefs[pref].Value.toString()), 1);
                        break;
                    case "WorkType":
                        params.PositionOfferingTypeCode.splice(params.PositionOfferingTypeCode.indexOf(prefs[pref].Value.toString()), 1);
                        break;
                    case "WorkSchedule":
                        params.PositionScheduleTypeCode.splice(params.PositionScheduleTypeCode.indexOf(prefs[pref].Value.toString()), 1);
                        break;
                    case "Location":
                        params.LocationName.splice(params.LocationName.indexOf(prefs[pref].Value.toString()), 1);
                        break;
                    case "TeleworkIndicator":
                        removedPrefs.push(pref);
                        params.TeleworkIndicator = null;
                        break;
                    case "RelocationIndicator":
                        removedPrefs.push(pref);
                        params.RelocationIndicator = null;
                        break;
                    case "RemoteIndicator":
                        removedPrefs.push(pref);
                        params.RemoteIndicator = null;
                        break;
                }
            }
        }
        hideRemoveAll();
        GlobalVariables.setParams(params);
        URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping(), true);
        GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates(), "search-prefs-toggle");
    }

    export function addPreferencePills() {
        var prefs = GlobalVariables.getProfilePreferences();
        var removedPrefs = GlobalVariables.getProfileRemovedPreferences();
        var params = GlobalVariables.getParams();
        var count = 0;
        params.Page = "1";
        for (var pref in prefs) {
            switch (prefs[pref].Type) {
                case "HiringPath":
                    if ($.inArray(prefs[pref].Value, params.HiringPath) == -1) {
                        params.HiringPath.push(prefs[pref].Value.toString());
                        count++;
                    } else {
                        removedPrefs.push(pref);
                    }
                    break;
                case "TravelPercentage":
                    if ($.inArray(prefs[pref].Value, params.TravelPercentage) == -1) {
                        params.TravelPercentage.push(prefs[pref].Value.toString());
                        count++;
                    } else {
                        removedPrefs.push(pref);
                    }
                    break;
                case "WorkType":
                    if ($.inArray(prefs[pref].Value, params.PositionOfferingTypeCode) == -1) {
                        if (prefs[pref].Value !== '15669') {
                            params.PositionOfferingTypeCode.push(prefs[pref].Value.toString());
                            count++;
                        }
                    } else {
                        removedPrefs.push(pref);
                    }
                    break;
                case "WorkSchedule":
                    if ($.inArray(prefs[pref].Value, params.PositionScheduleTypeCode) == -1) {
                        params.PositionScheduleTypeCode.push(prefs[pref].Value.toString());
                        count++;
                    } else {
                        removedPrefs.push(pref);
                    }
                    break;
                case "Location":
                    if ($.inArray(prefs[pref].Value, params.LocationName) == -1) {
                        params.LocationName.push(prefs[pref].Value.toString());
                        count++;
                    } else {
                        removedPrefs.push(pref);
                    }
                    break;
                case "TeleworkIndicator":
                    if (prefs[pref].Value === "true" || prefs[pref].Value === true) {
                        params.TeleworkIndicator = true;
                        count++;
                    } else {
                        params.TeleworkIndicator = null;
                    }
                    break;
                case "RelocationIndicator":
                    if (prefs[pref].Value === "true" || prefs[pref].Value === true) {
                        params.RelocationIndicator = true;
                        count++;
                    } else {
                        params.RelocationIndicator = null;
                    }
                    break;
                case "RemoteIndicator":
                    if (prefs[pref].Value === "true") {
                        params.RemoteIndicator = "true";
                        count++;
                    } else {
                        params.RemoteIndicator = "false";
                        count++;
                    }
                    break;
            }
        }
        GlobalVariables.setProfileFilterCount(count);
        $("#search-prefs-count").text(GlobalVariables.getProfileFilterCount());
        GlobalVariables.setParams(params);
        GlobalVariables.setProfileRemovedPreferences(removedPrefs);
        URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping(), true);
        GlobalFunctions.display(API.current.GetResults(GlobalVariables.getParams()), GlobalVariables.getTemplates(), "search-prefs-toggle");
    }

    export function convertSeriesFamilyToSeries(params: Params) {
        $.each(params.JobCategoryFamily, function(i, key) {
            var seriesFamily = DataConversion.getSeriesByFamily(key)
            for (var series in seriesFamily.Children) {
                if ($.inArray(series, params.JobCategoryCode) == -1) {
                    params.JobCategoryCode.push(series);
                }
            }
        });
        params.JobCategoryFamily = [];
        GlobalVariables.setParams(params);
        URLCriteriaHelper.ConstructURL(GlobalVariables.getParams(), GlobalVariables.getAliasMapping(), true);

        return params;
    }

    export function removePreferencePill(id) {
        var filterCount = GlobalVariables.getProfileFilterCount() - 1;
        GlobalVariables.setProfileFilterCount(filterCount);
        var removedPrefs = GlobalVariables.getProfileRemovedPreferences();
        removedPrefs.push(id);
        GlobalVariables.setProfileRemovedPreferences(removedPrefs);
        if (filterCount === 0 && $("#search-prefs-toggle").attr("data-state") === "is-active") {
            disableProfilePreferences();
        } else {
            $("#search-prefs-count").text(GlobalVariables.getProfileFilterCount());
        }
    }

    export function disableProfilePreferences() {
        if (usaj_ga) {
            usaj_ga.log_event_no_hostname("profile preferences", "click off", location.href);
        }
        $("#search-prefs-toggle").attr("data-state", "is-inactive");
        $('#search-prefs-text').text('no longer');
        sessionStorage.setItem("profilePreferences", "false");
    }

    export function enableProfilePreferences() {
        if (usaj_ga) {
            usaj_ga.log_event_no_hostname("profile preferences", "click on", location.href);
        }
        $("#search-prefs-toggle").attr('data-state', 'is-active');
        $('#search-prefs-text').text('now');
        sessionStorage.setItem("profilePreferences", "true");
    }

    export function hideRemoveAll() {
        if (!$('.usajobs-search-pills__list').find('.usajobs-search-pills__item').not("#search-pills-master-pill").length) {
            $('#search-pills-remove-all').attr('aria-hidden', 'true');
        }
    }

    export function isIEorEdge() {
        var agent = window.navigator.userAgent;
        var isIEorEdge = /msie\s|trident\/|edge\//i.test(agent);
        return isIEorEdge;
    }
}
